<template>
    <div>
        <b-form-group class="container-input-x">
            <template slot="label">
                <div class="label">{{ $t('nBox.xAxis') }}</div>
            </template>
            <b-form-input
                class="input-x"
                no-wheel
                type="number"
                :value="xValue"
                :state="state.x"
                @input="$emit('update:xValue', $event)"
            />
        </b-form-group>
        <b-form-group class="container-input-y">
            <template slot="label">
                <div class="label">{{ $t('nBox.yAxis') }}</div>
            </template>
            <b-form-input
                class="input-y"
                no-wheel
                type="number"
                :value="yValue"
                :state="state.y"
                @input="$emit('update:yValue', $event)"
            />
        </b-form-group>
    </div>
</template>
<script>
export default {
    props: {
        xValue: {
            type: [String, Number],
            default: null,
        },
        yValue: {
            type: [String, Number],
            default: null,
        },
        state: {
            type: Object,
            required: true,
        },
    },
}
</script>
